import $i18n from '../../../../i18n';

export const TimeSelectOptions = [
  {
    value: 'thisMonth',
    label: $i18n.get({ id: 'aopf.component.monitoringDashboard.const.CurrentMonth', dm: '当月' }),
  },
  {
    value: 'week',
    label: $i18n.get({ id: 'aopf.component.monitoringDashboard.const.NearlyAWeek', dm: '近一周' }),
  },
  {
    value: 'month',
    label: $i18n.get({ id: 'aopf.component.monitoringDashboard.const.LastMonth', dm: '近一月' }),
  },
  {
    value: 'quarter',
    label: $i18n.get({
      id: 'aopf.component.monitoringDashboard.const.RecentQuarter',
      dm: '近一季度',
    }),
  },
  {
    value: 'year',
    label: $i18n.get({
      id: 'aopf.component.monitoringDashboard.const.NearlyOneYear',
      dm: '近一年',
    }),
  },
];

export const ChartTitleTypes = {
  thisMonth: $i18n.get({ id: 'aopf.component.monitoringDashboard.const.Daily', dm: '每日' }),
  week: $i18n.get({ id: 'aopf.component.monitoringDashboard.const.Daily', dm: '每日' }),
  month: $i18n.get({ id: 'aopf.component.monitoringDashboard.const.Daily', dm: '每日' }),
  quarter: $i18n.get({ id: 'aopf.component.monitoringDashboard.const.Weekly', dm: '每周' }),
  year: $i18n.get({ id: 'aopf.component.monitoringDashboard.const.Monthly', dm: '每月' }),
};
